import * as React from 'react';
import { createPortal } from 'react-dom';
import { Info } from '@wix/wix-ui-icons-common/on-stage';
import { classes } from './TestSessionBanner.st.css';
import { TestSessionBannerDataHooks } from './TestSessionBannerDataHooks';
var SITE_CONTAINER_ID = 'SITE_CONTAINER';
var HOST_ATTRIBUTE = 'data-test-session-banner-host';
var OWNED_ATTRIBUTE = 'data-test-session-banner-owned';
var RELEASE_EVENT = 'test-session-banner-release';
var getOrCreateHost = function () {
    var existing = document.querySelector("[".concat(HOST_ATTRIBUTE, "]"));
    if (existing) {
        return existing;
    }
    var element = document.createElement('div');
    element.setAttribute(HOST_ATTRIBUTE, '');
    element.className = classes.host;
    var siteContainer = document.getElementById(SITE_CONTAINER_ID);
    if (siteContainer === null || siteContainer === void 0 ? void 0 : siteContainer.parentNode) {
        siteContainer.parentNode.insertBefore(element, siteContainer);
    }
    else {
        document.body.prepend(element);
    }
    return element;
};
export var TestSessionBanner = function (_a) {
    var text = _a.text;
    var _b = React.useState(null), host = _b[0], setHost = _b[1];
    React.useEffect(function () {
        var element = getOrCreateHost();
        var isOwner = false;
        var claim = function () {
            if (!element.hasAttribute(OWNED_ATTRIBUTE)) {
                element.setAttribute(OWNED_ATTRIBUTE, '');
                isOwner = true;
                setHost(element);
            }
        };
        claim();
        element.addEventListener(RELEASE_EVENT, claim);
        return function () {
            element.removeEventListener(RELEASE_EVENT, claim);
            if (!isOwner) {
                return;
            }
            element.removeAttribute(OWNED_ATTRIBUTE);
            element.dispatchEvent(new Event(RELEASE_EVENT));
            if (!element.hasAttribute(OWNED_ATTRIBUTE)) {
                element.remove();
            }
        };
    }, []);
    return host
        ? createPortal(React.createElement("div", { className: classes.root, role: "status", "data-hook": TestSessionBannerDataHooks.ROOT },
            React.createElement(Info, { className: classes.icon, "aria-hidden": true }),
            React.createElement("span", { className: classes.text }, text)), host)
        : null;
};
//# sourceMappingURL=TestSessionBanner.js.map